import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

const BONUS_POINTS = 'bonus_points'
const GRADE_PERCENTAGE = 'grade_percentage'
const COMMENT = 'comment'

/**
 * Form model
 */
const formModel = () => {
  return {
    [BONUS_POINTS]: {
      label: `${t('common.bonus-points-active-participation')}`,
      name: BONUS_POINTS
    },
    [GRADE_PERCENTAGE]: {
      label: `${t('common.grade-percentage')}`,
      name: GRADE_PERCENTAGE,
      type: 'number',
      required: true,
    },
    [COMMENT]: {
      label: `${t('common.assessment-feedback')}`,
      name: COMMENT
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [BONUS_POINTS]: '',
  [GRADE_PERCENTAGE]: '',
  [COMMENT]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [GRADE_PERCENTAGE]: yup
      .number()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
